export enum IncidentCauseCodeEnum {
  MEDICAL = 'MEDICAL',
  ONLINE_CARE = 'ONLINE_CARE',
  LUGGAGE = 'LUGGAGE',
  OTHER = 'OTHER'
}
